import EndCall from "../assets/phone.hang.fill.svg";
import Audio from "../assets/audio.fill.svg";
import AudioMute from "../assets/audio.slash.fill.svg";
import Video from "../assets/vid.fill.svg";
import VideoMute from "../assets/vid.slash.fill.svg";
import Channel from "../assets/tv.fill.svg";

const Icons = {
    endCall: EndCall,
    audio: Audio,
    audioMute: AudioMute,
    video: Video,
    videoMute: VideoMute,
    channel: Channel
}

export default Icons;